import * as React from 'react'

function SvgLoaderIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M21 12a9 9 0 10-9 9" stroke="currentColor" strokeWidth={1.6} />
    </svg>
  )
}

export default SvgLoaderIcon
